export default __webpack_public_path__ + "59df82b9ac177c67f37ca714010cd42d.svg";